<script setup>

import { onBeforeUnmount, onMounted, ref } from 'vue'

const props = defineProps({
  block: {
    type: Object,
    default: () => ({})
  }
})

const sectionRef = ref(null)
const parts = ref([])

const MIN_ACTIVE_TIME = 500
let currentActiveIndex = -1
let lastSwitchTime = 0
let rafId = null

const updateActivePart = () => {
  if (!parts.value.length) return

  const viewportMiddle = window.innerHeight / 2


  let bestIndex = 0
  let bestScore = Infinity 

  parts.value.forEach((part, index) => {
    const rect = part.getBoundingClientRect()
    const centerY = rect.top + rect.height / 2
    const containsCenter = rect.top <= viewportMiddle && rect.bottom >= viewportMiddle
    const distanceToCenter = Math.abs(viewportMiddle - centerY)
    const score = containsCenter ? 0 : distanceToCenter

    if (score < bestScore) {
      bestScore = score
      bestIndex = index
    }
  })

  const now = Date.now()
  if (bestIndex !== currentActiveIndex) {
    if (now - lastSwitchTime < MIN_ACTIVE_TIME) return
    currentActiveIndex = bestIndex
    lastSwitchTime = now
  }

  parts.value.forEach((part, index) => {
    part.classList.toggle('is-visible', index === currentActiveIndex)
  })
}

const handleScroll = () => {
  if (rafId) return
  rafId = window.requestAnimationFrame(() => {
    rafId = null
    updateActivePart()
  })
}

onMounted(() => {
  if (!sectionRef.value) return

  parts.value = Array.from(sectionRef.value.querySelectorAll('.part'))
  if (!parts.value.length) return

  updateActivePart()
  window.addEventListener('scroll', handleScroll, { passive: true })
  window.addEventListener('resize', handleScroll)
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll)
  window.removeEventListener('resize', handleScroll)
  if (rafId) {
    window.cancelAnimationFrame(rafId)
    rafId = null
  }
})

</script>

<!-- -------------------------------------------------------------------------------------------------
    Template
------------------------------------------------------------------------------------------------- -->

<template>
<section ref="sectionRef" class="animated-highlight-text section-mb">
  <div class="container">

    <div class="animated-highlight-text__text"
      v-html="props.block?.['text']?.html"></div>

  </div>
</section>
</template>

<!-- -------------------------------------------------------------------------------------------------
    Styling
------------------------------------------------------------------------------------------------- -->

<style scoped>

.animated-highlight-text__text {
  max-width: 1213px;
  margin: 0 auto;
  text-align: center;
  font-family: 'Serrif', sans-serif;
  font-size: 28px;
  font-weight: 500;
  line-height: 120%;
  letter-spacing: -0.56px;
  color: #A8A39B;
  @media (min-width: 1024px) {
    font-size: 38px;
    letter-spacing: -0.76px;
  }
}

.animated-highlight-text__text :deep(.part) {
  color: #A8A39B;
  transition: color 0.3s ease;
}

.animated-highlight-text__text :deep(.part.is-visible) {
  color: #292016;
}

</style>
